import { AxiosInstance } from "../helpers/AxiosInstance";
import Config from "../config";

const searchMessageLogs = (data) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/search`, data);
}

const exportMessageLogs = (data) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/export`, data);
}

const downloadMesageLogs = (Id: string) => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/export/${Id}/download`, { responseType: 'arraybuffer' })
}

const getExportedMesageLogs = () => {
    return AxiosInstance.get(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/export/history`)
}

const deleteMessagelogexporthistory = (data: { Ids: string[] }) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/export/delete`, data)
};

const getMediaFileBase64Data = (data: any) => {
    return AxiosInstance.post(`${Config.API_SECOND_URL}/falkon/notify/api/v1/secureChat/messages/logs/media`, data)
};

export const SecureChatMessageLogService = {
    searchMessageLogs,
    exportMessageLogs,
    downloadMesageLogs,
    deleteMessagelogexporthistory,
    getExportedMesageLogs,
    getMediaFileBase64Data
};